import type { HistoryReason, Performance, PerformanceKind, PlaybackState, RepeatMode } from "../api/types";

export const KIND_LABEL: Record<PerformanceKind, string> = {
  original: "原曲",
  cover: "カバー",
  live: "ライブ",
  stream: "歌枠",
};

/** 種別の名前（契約の PerformanceView.kind は文字列なので、知らない値はそのまま出す） */
export function kindLabel(kind: string): string {
  if (kind === "video") return "動画";
  return (KIND_LABEL as Record<string, string>)[kind] ?? kind;
}

export const STATE_LABEL: Record<PlaybackState, string> = {
  idle: "停止中",
  loading: "読み込み中",
  playing: "再生中",
  paused: "一時停止中",
  recovering: "復旧中",
  interrupted: "中断",
  error: "エラー",
};

export const REPEAT_LABEL: Record<RepeatMode, string> = {
  off: "リピートなし",
  one: "1曲リピート",
  queue: "キューをリピート",
};

export const HISTORY_REASON_LABEL: Record<HistoryReason, string> = {
  completed: "最後まで再生",
  skipped: "スキップ",
  failed: "再生できず",
  interrupted: "中断",
  stopped: "終了操作",
};

export function performerNames(p: Pick<Performance, "performers" | "source_channel_name">): string {
  return p.performers.map((x) => x.name).join("・") ||
    (p.source_channel_name ? `${p.source_channel_name}（YouTubeチャンネル）` : "歌った人未登録");
}

/** 「夜明けのプリズム／星乃あかり」 */
export function performanceTitle(p: Performance): string {
  return `${p.work.title}／${performerNames(p)}`;
}
